import { UserRoleOwner } from "../../consts/UserRole";

class UserListDto {
    Id: number;
    Email: string;
    FirstName: string;
    LastName: string;
    IsOwner: boolean;
    UserRole: number;
    RoleGroupIds: number[];
    Status: number;
    StatusLabel: string;

    constructor(id: number, email: string, firstName: string, lastName: string, role: number, status: number, roleGroupIds: number[] = []) {
        this.Id = id;
        this.Email = email;
        this.FirstName = firstName;
        this.LastName = lastName;
        this.IsOwner = role === UserRoleOwner;
        this.UserRole = role;
        this.RoleGroupIds = roleGroupIds;
        this.Status = status;
        this.StatusLabel = "";
        switch (status) {
            case 1: this.StatusLabel = "Invited"; break;
            case 2: this.StatusLabel = "Ok"; break;
            case 3: this.StatusLabel = "Revoked"; break;
        }
    }

    get Label(): string {
        if ((!this.FirstName || this.FirstName.trim() === '') && (!this.LastName || this.LastName.trim() === '')) {
            return this.Email;
        }
        return `${this.FirstName} ${this.LastName}`.trim();
    }
}

export default UserListDto;
